import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Notification } from '@app/models/notifications/notifications.model';
import { WaterStatusService } from '@app/models/water-status/water-status.service';

@Component({
    selector: 'app-usage-alert-notification',
    templateUrl: './usage-alert.component.html',
    styleUrls: ['../notification-types.scss'],
})
export class UsageAlertNotificationComponent implements OnInit {
    @Input() notification: Notification = { extra: {} } as Notification;
    @Input() entitlement: string = null;
    @Output() markedRead = new EventEmitter();
    @Output() deleteNotification = new EventEmitter();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private waterStatusService: WaterStatusService
    ) {}

    ngOnInit() {}

    queryAlertUsage() {
        const smartLeakAlert = this.notification.extra.advanced_low_flow === true && this.notification.extra.leak_id;
        if (smartLeakAlert) {
            this.waterStatusService.getActiveLeak(this.notification.device_id, this.notification.extra.leak_id);
            this.waterStatusService.triggerScrollToLeak();
        } else {
            const notif: Notification = this.notification;
            const params: Record<string, string> = {};
            params.since = notif.extra.query.since_datetime;
            params.scale = this.convertBucketToScale(notif.extra.query.bucket);
            params.new = 'true';

            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: params,
            });
            document.getElementById('top-page-hook').scrollIntoView();
        }
    }

    convertBucketToScale(bucket) {
        switch (bucket) {
            case 'MIN':
                return 'hour';
            case 'HR':
                return 'day';
            case 'DAY':
                return 'month';
            default:
                return 'month';
        }
    }
}
